import { useTranslation } from 'react-i18next';
import { InputFieldTime } from 'qampo-ui-library';
import { Toggle } from '../UI/base';
import { DAY_LABEL_KEYS, DAY_ORDER } from './staffScheduleConstants';
import type { DayKey, DaySchedule, WeekScheduleForm } from './staffScheduleConstants';
import styles from './WeeklyScheduleEditor.module.css';

interface WeeklyScheduleEditorProps {
  value: WeekScheduleForm;
  dayErrors: Partial<Record<DayKey, string>>;
  onChange: (next: WeekScheduleForm) => void;
}

export const WeeklyScheduleEditor = ({ value, dayErrors, onChange }: WeeklyScheduleEditorProps) => {
  const { t } = useTranslation();

  const updateDay = (day: DayKey, patch: Partial<DaySchedule>) => {
    onChange({ ...value, [day]: { ...value[day], ...patch } });
  };

  return (
    <div className={styles.editor}>
      {DAY_ORDER.map((day) => {
        const daySchedule = value[day];
        const error = dayErrors[day];
        return (
          <div key={day} className={styles.row}>
            <label className={styles.dayToggle}>
              <Toggle
                checked={daySchedule.enabled}
                onChange={(checked) => updateDay(day, { enabled: checked })}
              />
              <span className={styles.dayLabel}>{t(DAY_LABEL_KEYS[day])}</span>
            </label>
            <div className={styles.times}>
              <InputFieldTime
                width={110}
                value={daySchedule.startTime}
                disable={!daySchedule.enabled}
                error={Boolean(error)}
                onChange={(e) => updateDay(day, { startTime: e.target.value })}
              />
              <span className={styles.separator}>&ndash;</span>
              <InputFieldTime
                width={110}
                value={daySchedule.endTime}
                disable={!daySchedule.enabled}
                error={Boolean(error)}
                onChange={(e) => updateDay(day, { endTime: e.target.value })}
              />
            </div>
            {error && <span className={styles.error}>{error}</span>}
          </div>
        );
      })}
    </div>
  );
};
